/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Delete_Error_TitleInputs */

const es_admin_users_delete_error_title = /** @type {(inputs: Admin_Users_Delete_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar usuario`)
};

const en_admin_users_delete_error_title = /** @type {(inputs: Admin_Users_Delete_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting user`)
};

/**
* | output |
* | --- |
* | "Error deleting user" |
*
* @param {Admin_Users_Delete_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_delete_error_title = /** @type {((inputs?: Admin_Users_Delete_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Delete_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_delete_error_title(inputs)
	return en_admin_users_delete_error_title(inputs)
});
export { admin_users_delete_error_title as "admin.users.delete.error.title" }